class PredictiveSearch extends HTMLElement {
    constructor() {
        super();

        this.input = this.querySelector('input[type="search"]');
        this.form = this.querySelector('#searchInCollection');
        this.predictiveSearchResults = this.querySelector('#predictive-search1');

        this.form.addEventListener('submit', (event) => {
            event.preventDefault();
            const inputValue = event.target.querySelector('input[name="q"]').value;

            const encodedInputValue = encodeURIComponent(inputValue);
            const collectionHandle = event.target.dataset.collectionHandle;
            const collectionTitle = event.target.dataset.collectionTitle.replace(/ /g, "+");
            const collectionLevelFilter = event.target.dataset.collectionLevelFilter;
            let actionURL = `${event.target.action}?q=tag:${collectionHandle}%20AND%20${encodedInputValue}`;
            if (collectionHandle === 'all'){
                actionURL = `${event.target.action}?q=${encodedInputValue}`;
            }
            if (collectionLevelFilter.length > 0) {
                actionURL = `${event.target.action}?${collectionLevelFilter}=${collectionTitle}&q=${encodedInputValue}`;
            }

            event.target.action = actionURL;
            window.location.href = actionURL
//      event.target.submit();

        })

        this.input.addEventListener('input', this.debounce((event) => {
            this.onChange(event);
        }, 300).bind(this));
    }

    formSubmit(actionURL) {
        console.log(actionURL)
    }

    onChange() {
        const searchTerm = this.input.value.trim();

        if (!searchTerm.length) {
            this.close();
            return;
        }

        const {collectionHandle} = this.input.dataset;

        this.getSearchResults(searchTerm, collectionHandle);
    }

    getSearchResults(searchTerm, collectionHandle) {
        fetch(`/search/suggest?q=tag:${collectionHandle} AND ${searchTerm}&resources[type]=product&resources[limit]=10&section_id=predictive-search1`)
            .then((response) => {
                if (!response.ok) {
                    var error = new Error(response.status);
                    this.close();
                    throw error;
                }

                return response.text();
            })
            .then((text) => {
                const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search1').innerHTML;
                this.predictiveSearchResults.innerHTML = resultsMarkup;
                this.open();
            })
            .catch((error) => {
                this.close();
                throw error;
            });
    }

    open() {
        this.predictiveSearchResults.style.display = 'block';
    }

    close() {
        this.predictiveSearchResults.style.display = 'none';
    }

    debounce(fn, wait) {
        let t;
        return (...args) => {
            clearTimeout(t);
            t = setTimeout(() => fn.apply(this, args), wait);
        };
    }
}

customElements.define('predictive-search', PredictiveSearch);
